import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
} from "reactstrap";

import {
    FiFileText,
    FiShield,
    FiChevronRight,
    FiAlertCircle,
    FiLink,
} from "react-icons/fi";

import "./TermsAndConditionsPage.css";
import SEO from "../../components/common/seo/SEO";


const TermsAndConditionsPage = () => {

    const sections = [
        {
            id: "website-use",
            title: "Website Use",
        },
        {
            id: "cookies",
            title: "Cookies",
        },
        {
            id: "information-accuracy",
            title: "Information Accuracy",
        },
        {
            id: "user-responsibility",
            title: "User Responsibility",
        },
        {
            id: "intellectual-property",
            title: "Intellectual Property",
        },
        {
            id: "unauthorized-use",
            title: "Unauthorized Use",
        },
        {
            id: "external-links",
            title: "External Links",
        },
        {
            id: "governing-law",
            title: "Governing Law",
        },
    ];


    return (
        <>
            <SEO
                title="Terms & Conditions | FeesWorth"
                description="Read the Terms and Conditions governing the use of the FeesWorth website, including website usage, cookies, information accuracy, intellectual property, external links, and governing law."

                keywords="FeesWorth Terms and Conditions, FeesWorth terms, website terms and conditions, FeesWorth policies, website usage terms"

                canonical="https://feesworth.com/terms-and-conditions"
            />

            <main className="terms-page">

                {/* =========================================
                HERO
            ========================================= */}

                <section className="terms-hero">

                    <Container>

                        <div className="terms-hero-content">

                            <div className="terms-hero-icon">
                                <FiFileText />
                            </div>

                            <span className="terms-eyebrow">
                                FEESWORTH
                            </span>

                            <h1>
                                Terms & Conditions
                            </h1>

                            <p>
                                Please read these terms and conditions carefully
                                before using the FeesWorth website and its
                                services.
                            </p>

                            <div className="terms-notice">

                                <FiShield />

                                <span>
                                    By using this website, you agree to comply
                                    with these terms and conditions.
                                </span>

                            </div>

                        </div>

                    </Container>

                </section>


                {/* =========================================
                CONTENT
            ========================================= */}

                <section className="terms-content">

                    <Container>

                        <Row className="g-5">

                            {/* =================================
                            SIDEBAR
                        ================================= */}

                            <Col
                                lg="3"
                                className="terms-sidebar-col"
                            >

                                <div className="terms-sidebar">

                                    <div className="terms-sidebar-title">

                                        <FiFileText />

                                        <span>
                                            On This Page
                                        </span>

                                    </div>


                                    <nav>

                                        {sections.map((section, index) => (

                                            <a
                                                key={section.id}
                                                href={`#${section.id}`}
                                            >

                                                <span className="terms-nav-number">
                                                    {String(index + 1).padStart(2, "0")}
                                                </span>

                                                <span>
                                                    {section.title}
                                                </span>

                                                <FiChevronRight />

                                            </a>

                                        ))}

                                    </nav>

                                </div>

                            </Col>


                            {/* =================================
                            MAIN DOCUMENT
                        ================================= */}

                            <Col lg="9">

                                <Card className="terms-card">

                                    <CardBody>


                                        {/* =================================
                                        INTRODUCTION
                                    ================================= */}

                                        <section className="terms-section terms-introduction">

                                            <div className="terms-intro-box">

                                                <FiAlertCircle />

                                                <p>
                                                    Welcome to our website. If you
                                                    continue to browse and use this
                                                    website, you are agreeing to
                                                    comply with and be bound by the
                                                    following terms and conditions
                                                    of use. If you disagree with any
                                                    part of these terms and
                                                    conditions, please do not use
                                                    our website.
                                                </p>

                                            </div>


                                            <p>
                                                The term ‘FeesWorth or ‘us’ or ‘we’
                                                refers to FEESWORTH Having it
                                                registered office at
                                                <strong>
                                                    {" "}#14, First Floor, 3rd
                                                    Cross, Muneshwara Layout,
                                                    Kudlu Gate, Bangalore –
                                                    560068.
                                                </strong>
                                            </p>

                                            <p>
                                                The term ‘you’ refers to the user
                                                or viewer of our website.
                                            </p>


                                            <div className="terms-agreement-box">

                                                <FiShield />

                                                <div>

                                                    <span>
                                                        IMPORTANT
                                                    </span>

                                                    <strong>
                                                        Website Terms of Use
                                                    </strong>

                                                    <p>
                                                        The use of this website is
                                                        subject to the following
                                                        terms of use.
                                                    </p>

                                                </div>

                                            </div>

                                        </section>


                                        {/* =================================
                                        01 WEBSITE USE
                                    ================================= */}

                                        <section
                                            id="website-use"
                                            className="terms-section"
                                        >

                                            <SectionTitle
                                                number="01"
                                                title="Website Use"
                                            />

                                            <div className="terms-item">

                                                <div className="terms-item-icon">
                                                    <FiFileText />
                                                </div>

                                                <div>

                                                    <h3>
                                                        Website Content
                                                    </h3>

                                                    <p>
                                                        The content of the pages of
                                                        this website is for your
                                                        general information and use
                                                        only. It is subject to
                                                        change without notice.
                                                    </p>

                                                </div>

                                            </div>

                                        </section>


                                        {/* =================================
                                        02 COOKIES
                                    ================================= */}

                                        <section
                                            id="cookies"
                                            className="terms-section"
                                        >

                                            <SectionTitle
                                                number="02"
                                                title="Cookies"
                                            />

                                            <div className="terms-item">

                                                <div className="terms-item-icon">
                                                    <FiShield />
                                                </div>

                                                <div>

                                                    <h3>
                                                        Cookie Usage
                                                    </h3>

                                                    <p>
                                                        This website uses cookies to
                                                        monitor browsing preferences.
                                                        If you do allow cookies to be
                                                        used, personal information
                                                        may be stored by us for use
                                                        by third parties.
                                                    </p>

                                                </div>

                                            </div>

                                        </section>


                                        {/* =================================
                                        03 INFORMATION ACCURACY
                                    ================================= */}

                                        <section
                                            id="information-accuracy"
                                            className="terms-section"
                                        >

                                            <SectionTitle
                                                number="03"
                                                title="Information Accuracy"
                                            />

                                            <div className="terms-item">

                                                <div className="terms-item-icon">
                                                    <FiAlertCircle />
                                                </div>

                                                <div>

                                                    <h3>
                                                        Accuracy & Disclaimer
                                                    </h3>

                                                    <p>
                                                        Neither we nor any third
                                                        parties provide any warranty
                                                        or guarantee as to the
                                                        accuracy, timeliness,
                                                        performance, completeness or
                                                        suitability of the
                                                        information and materials
                                                        found or offered on this
                                                        website for any particular
                                                        purpose.
                                                    </p>

                                                    <p>
                                                        You acknowledge that such
                                                        information and materials
                                                        may contain inaccuracies or
                                                        errors and we expressly
                                                        exclude liability for any
                                                        such inaccuracies or errors
                                                        to the fullest extent
                                                        permitted by law.
                                                    </p>

                                                </div>

                                            </div>

                                        </section>


                                        {/* =================================
                                        04 USER RESPONSIBILITY
                                    ================================= */}

                                        <section
                                            id="user-responsibility"
                                            className="terms-section"
                                        >

                                            <SectionTitle
                                                number="04"
                                                title="User Responsibility"
                                            />

                                            <div className="terms-item">

                                                <div className="terms-item-icon">
                                                    <FiShield />
                                                </div>

                                                <div>

                                                    <h3>
                                                        Your Use of Information
                                                    </h3>

                                                    <p>
                                                        Your use of any information
                                                        or materials on this website
                                                        is entirely at your own risk,
                                                        for which we shall not be
                                                        liable.
                                                    </p>

                                                    <p>
                                                        It shall be your own
                                                        responsibility to ensure that
                                                        any products, services or
                                                        information available through
                                                        this website meet your
                                                        specific requirements.
                                                    </p>

                                                </div>

                                            </div>

                                        </section>


                                        {/* =================================
                                        05 INTELLECTUAL PROPERTY
                                    ================================= */}

                                        <section
                                            id="intellectual-property"
                                            className="terms-section"
                                        >

                                            <SectionTitle
                                                number="05"
                                                title="Intellectual Property"
                                            />

                                            <div className="terms-item">

                                                <div className="terms-item-icon">
                                                    <FiFileText />
                                                </div>

                                                <div>

                                                    <h3>
                                                        Website Materials
                                                    </h3>

                                                    <p>
                                                        This website contains
                                                        material which is owned by or
                                                        licensed to us.
                                                    </p>

                                                    <p>
                                                        This material includes, but
                                                        is not limited to, the
                                                        design, layout, look,
                                                        appearance and graphics.
                                                    </p>

                                                </div>

                                            </div>


                                            <div className="terms-highlight">

                                                <FiFileText />

                                                <span>
                                                    Reproduction is prohibited
                                                    other than in accordance with
                                                    the copyright notice, which
                                                    forms part of these terms and
                                                    conditions.
                                                </span>

                                            </div>

                                        </section>


                                        {/* =================================
                                        06 UNAUTHORIZED USE
                                    ================================= */}

                                        <section
                                            id="unauthorized-use"
                                            className="terms-section"
                                        >

                                            <SectionTitle
                                                number="06"
                                                title="Unauthorized Use"
                                            />

                                            <div className="terms-item">

                                                <div className="terms-item-icon terms-danger-icon">
                                                    <FiAlertCircle />
                                                </div>

                                                <div>

                                                    <h3>
                                                        Prohibited Use
                                                    </h3>

                                                    <p>
                                                        Unauthorized use of this
                                                        website may give rise to a
                                                        claim for damages and/or be a
                                                        criminal offence.
                                                    </p>

                                                </div>

                                            </div>

                                        </section>


                                        {/* =================================
                                        07 EXTERNAL LINKS
                                    ================================= */}

                                        <section
                                            id="external-links"
                                            className="terms-section"
                                        >

                                            <SectionTitle
                                                number="07"
                                                title="External Links"
                                            />

                                            <div className="terms-item">

                                                <div className="terms-item-icon">
                                                    <FiLink />
                                                </div>

                                                <div>

                                                    <h3>
                                                        Links to Other Websites
                                                    </h3>

                                                    <p>
                                                        From time to time, this
                                                        website may also include
                                                        links to other websites.
                                                        These links are provided for
                                                        your convenience to provide
                                                        further information.
                                                    </p>

                                                    <p>
                                                        They do not signify that we
                                                        endorse the website(s). We
                                                        have no responsibility for
                                                        the content of the linked
                                                        website(s).
                                                    </p>

                                                </div>

                                            </div>

                                        </section>


                                        {/* =================================
                                        08 GOVERNING LAW
                                    ================================= */}

                                        <section
                                            id="governing-law"
                                            className="terms-section terms-last-section"
                                        >

                                            <SectionTitle
                                                number="08"
                                                title="Governing Law"
                                            />

                                            <div className="terms-law-box">

                                                <FiShield />

                                                <div>

                                                    <h3>
                                                        Applicable Law
                                                    </h3>

                                                    <p>
                                                        Your use of this website and
                                                        any dispute arising out of
                                                        such use of the website is
                                                        subject to the laws of Tamil
                                                        India.
                                                    </p>

                                                </div>

                                            </div>

                                        </section>

                                    </CardBody>

                                </Card>

                            </Col>

                        </Row>

                    </Container>

                </section>

            </main>

        </>
    );
};


/* =========================================================
   SECTION TITLE COMPONENT
========================================================= */

const SectionTitle = ({ number, title }) => {

    return (
        <div className="terms-section-title">

            <span className="terms-section-number">
                {number}
            </span>

            <h2>
                {title}
            </h2>

        </div>
    );
};


export default TermsAndConditionsPage;